import {IController} from "../../../controllers/IController";
import {InjectionToken} from "@angular/core";
import {ModelKey} from "../../../models/ModelKey";
import {ViewTitleModel} from "../_models/ViewTitleModel";
import {ControllerEvent} from "../../../event-buses/ControllerEvent";

export const IT_VIEW_TITLE_CONTROLLER = new InjectionToken<IViewTitleController>('IT_VIEW_TITLE_CONTROLLER');
export const IT_TITLE = new InjectionToken<string>('IT_TITLE');
export const IT_EXTRA_INFO_CONTENTS = new InjectionToken<string>('IT_EXTRA_INFO_CONTENTS');

export const MK_VIEW_TITLE = new ModelKey<ViewTitleModel>('MK_VIEW_TITLE');

export interface IViewTitleController extends IController {

  onUpdateTitle(event: ControllerEvent): void;
}
